import { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Menu, X } from "lucide-react";
import { useCart } from "../../context/CartContext";

const Navbar = () => {
    const [open, setOpen] = useState(false);

    const {
    cartItems
  } = useCart();

  const cartCount = cartItems.reduce(
  (total, item) => total + item.quantity,
  0
);

    return (
        <header className="bg-white border-b sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

                {/* Logo */}
                <Link
                    to="/"
                    className="text-2xl font-bold text-green-600"
                >
                    AfyaEquip
                </Link>


                {/* Desktop Menu */}
                <nav className="hidden md:flex items-center gap-8 text-gray-700 font-medium">
                    <Link to="/" className="hover:text-green-600 transition">
                        Home
                    </Link>

                    <Link to="/shop" className="hover:text-green-600 transition">
                        Shop
                    </Link>

                    <Link to="/tips" className="hover:text-green-600 transition">
                        Tips
                    </Link>

                    <Link to="/contact" className="hover:text-green-600 transition">
                        Contact
                    </Link>
                </nav>


                {/* Actions */}
                <div className="flex items-center gap-5">

                    <Link
  to="/cart"
  className="
    relative
    text-gray-700
    hover:text-green-600
    transition
  "
>

  <ShoppingCart size={26}/>


  {
    cartCount > 0 && (

      <span
        className="
          absolute
          -top-2
          -right-2
          bg-green-600
          text-white
          text-xs
          w-5
          h-5
          rounded-full
          flex
          items-center
          justify-center
          font-semibold
        "
      >
        {cartCount}
      </span>

    )
  }


</Link>

                    <button
                        onClick={() => setOpen(!open)}
                        className="md:hidden"
                    >
                        {open ? <X /> : <Menu />}
                    </button>

                </div>

            </div>


            {/* Mobile Menu */}
            {open && (
                <div className="md:hidden border-t bg-white px-6 py-5">
                    <nav className="flex flex-col gap-5 text-gray-700 font-medium">

                        <Link onClick={() => setOpen(false)} to="/">
                            Home
                        </Link>

                        <Link onClick={() => setOpen(false)} to="/shop">
                            Shop
                        </Link>

                        <Link onClick={() => setOpen(false)} to="/tips">
                            Tips
                        </Link>

                        <Link onClick={() => setOpen(false)} to="/contact">
                            Contact
                        </Link>

                    </nav>
                </div>
            )}

        </header>
    );
};

export default Navbar;